import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import Welcome from "@components/Welcome";


const WelcomePage = () => {

    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;
    const customBackgroundColour = whiteLabel?.subscriber_group?.subscriber_group_welcome_page?.page_background_color;


    return (
        <div className="refresh__wrapper" style={{ backgroundColor: customBackgroundColour || "black" }}>
            <Helmet>
                <title>{ `Welcome | Movies in Cinemas Now | ${brand}` }</title>
                <meta name="keywords" content={ `Lets get started | Movies in Cinemas Now | ${brand}` } />
                <meta name="description" content={ `Discover movies now showing in regional cinemas across Australia.
                Get information on movie tickets, screening locations,
                showtimes & more. Only at ${brand}!` } />
                <link rel="canonical" href={`${window.location.protocol }//${ window.location.host}/lets-get-started`} />
                <style type="text/css">
                    {`
                    html {
                      background-color: ${customBackgroundColour || "black"};
                    }
                  `}
                </style>
            </Helmet>
            <Welcome />

        </div>


    );
};

export default WelcomePage;
